import { isUserInternal } from './comments.config'
import type { ComposerEditorMentionSuggestionsProps } from '@liveblocks/react-ui/primitives'
import { Composer } from '@liveblocks/react-ui/primitives'

import { useCommentAudience } from './context'
import { MentionSuggestionItem } from './mention-suggestion-item'

export const EditorMentionSuggestions = ({ mentions }: ComposerEditorMentionSuggestionsProps) => {
  const audience = useCommentAudience()
  const visibleMentions =
    audience === 'external' ? mentions : mentions.filter((mention) => isUserInternal(mention.id))

  if (visibleMentions.length === 0) return null

  return (
    <Composer.Suggestions className='pointer-events-auto z-max w-60 rounded border border-main-border-default bg-main-background-card py-1 shadow-md'>
      <Composer.SuggestionsList>
        {visibleMentions.map((mention) => (
          <MentionSuggestionItem key={mention.id} userId={mention.id} />
        ))}
      </Composer.SuggestionsList>
    </Composer.Suggestions>
  )
}
